define('SuiteCommerce.OrderStatus.OrderFinder.SearchResults.View',
  [
    'suitecommerce_orderstatus_search_results.tpl',
    'SuiteCommerce.OrderStatus.OrderFinder.OrderSummary.View',
    'SuiteCommerce.OrderStatus.OrderFinder.OrderPaymentInfo.View',
    'SuiteCommerce.OrderStatus.OrderFinder.ItemDetails.View',
    'SuiteCommerce.OrderStatus.Utils',
    'Backbone',
    'Backbone.CompositeView',
    'underscore'
  ],
  function define(
    Template,
    OrderSummaryView,
    OrderPaymentInfoView,
    ItemDetailsView,
    Utils,
    Backbone,
    BackboneFormView,
    _
  ) {
    'use strict';
    return Backbone.View.extend({
      ORDER_STATUSES_TO_HIGHLIGHT: {
        error: ['Cancelled']
      },
      ITEM_FULFILLMENT_CHOICE_MAPPING: {
        ship: 'SHIP',
        pickupInStore: 'PICKUP_IN_STORE'
      },
      template: Template,
      events: {
        'click [data-action="resetSearch"]': 'resetSearch',
        'click [data-action="openItemDetails"]': 'openItemDetails'
      },
      childViews: {
        'OrderFinder.Summary': function registerOrderSummaryDataView() {
          return new OrderSummaryView({
            summaryData: this.model.get('details').transactionData,
            currency: this.model.get('details').currency
          });
        },
        'OrderFinder.PaymentInfo': function registerOrderPaymentInfoView() {
          return new OrderPaymentInfoView({
            paymentData: this.model.get('details').paymentData
          });
        }
      },
      initialize: function initialize(options) {
        this.model = options.model;
        this.title = Utils.getConfigurationParameter('pageTitle');
        this.initializeOrderConstant();
        BackboneFormView.add(this);
      },
      initializeOrderConstant: function initializeOrderConstant() {
        this.ORDER_STATUS_MAPPING = {
          'Pending Approval': Utils.getConfigurationParameter('orderDetailsOrderStatusPendingApproval'),
          'Pending Fulfillment': Utils.getConfigurationParameter('orderDetailsOrderStatusPendingFulfillment'),
          'Partially Fulfilled': Utils.getConfigurationParameter('orderDetailsOrderStatusPartiallyShipped'),
          // eslint-disable-next-line quote-props
          'Fulfilled': Utils.getConfigurationParameter('orderDetailsOrderStatusFulfilled'),
          'Pending Billing': Utils.getConfigurationParameter('orderDetailsOrderStatusPendingBilling'),
          // eslint-disable-next-line quote-props
          'Billed': Utils.getConfigurationParameter('orderDetailsOrderStatusBilled'),
          // eslint-disable-next-line quote-props
          'Closed': Utils.getConfigurationParameter('orderDetailsOrderStatusClosed'),
          // eslint-disable-next-line quote-props
          'Cancelled': Utils.getConfigurationParameter('orderDetailsOrderStatusCanceled'),
          // eslint-disable-next-line quote-props
          'Canceled': Utils.getConfigurationParameter('orderDetailsOrderStatusCanceled')
        };
        this.ITEMS_STATUS_MAPPING = {
          SHIPPING_ITEMS_PENDING_FULFILLMENT_LABEL: Utils.getConfigurationParameter('orderDetailsShippingItemsWithoutFulfillmentLabel'),
          SHIPPING_ITEMS_PICKED_LABEL: Utils.getConfigurationParameter('orderDetailsShippingItemsPickedLabel'),
          SHIPPING_ITEMS_PACKED_LABEL: Utils.getConfigurationParameter('orderDetailsShippingItemsPackedLabel'),
          SHIPPING_ITEMS_SHIPPED_LABEL: Utils.getConfigurationParameter('orderDetailsShippingItemsShippedLabel'),
          PICKUP_ITEMS_PENDING_FULFILLMENT_LABEL: Utils.getConfigurationParameter('orderDetailsPickupItemsWithoutFulfillmentLabel'),
          PICKUP_ITEMS_PICKED_LABEL: Utils.getConfigurationParameter('orderDetailsPickupItemsPickedLabel'),
          PICKUP_ITEMS_PICKED_UP_LABEL: Utils.getConfigurationParameter('orderDetailsPickupItemsPickedUpLabel'),
          ITEMS_PENDING_APPROVAL_LABEL: Utils.getConfigurationParameter('orderDetailsOrderStatusPendingApproval'),
          ITEMS_CANCELLED_LABEL: Utils.getConfigurationParameter('orderDetailsOrderStatusCanceled')
        };
      },
      getBreadcrumbPages: function getBreadcrumbPages() {
        return [{
          text: this.title,
          href: '/' + Utils.getConfigurationParameter('route')
        }];
      },
      resetSearch: function resetSearch() {
        this.model.destroy();
      },
      getContext: function getContext() {
        var processedOrderDetails = this.getProcessedOrderDetails();
        this.model.set('details', processedOrderDetails);
        return {
          title: this.title,
          orderDetails: processedOrderDetails,
          viewElements: {
            searchButtonLabel: Utils.getConfigurationParameter('orderDetailsNewSearchButtonLabel'),
            orderNumberLabel: Utils.getConfigurationParameter('orderDetailsOrderNumber').replace(
              '{{ordernumber}}',
              this.model.get('details').orderNumber
            ),
            orderStatus: {
              label: this.model.get('details').status,
              show: true
            },
            orderDate: {
              label: Utils.getConfigurationParameter('orderDetailsDateOrderedLabel').replace(
                '{{orderdate}}',
                this.model.get('details').orderDate
              ),
              show: true
            },
            itemColumn: {
              label: Utils.getConfigurationParameter('orderDetailsItemColumnLabel'),
              show: !!Utils.getConfigurationParameter('orderDetailsItemColumnLabel')
            },
            quantityColumn: {
              label: Utils.getConfigurationParameter('orderDetailsQuantityColumnLabel'),
              show: !!Utils.getConfigurationParameter('orderDetailsQuantityColumnLabel')
            },
            statusColumn: {
              label: Utils.getConfigurationParameter('orderDetailsStatusColumnLabel'),
              show: !!Utils.getConfigurationParameter('orderDetailsStatusColumnLabel')
            },
            trackPackage: {
              label: Utils.getConfigurationParameter('orderDetailsTrackPackageLabel'),
              show: !!Utils.getConfigurationParameter('orderDetailsTrackPackageLabel')
            },
            shipDifferentAddressLabel: Utils.getConfigurationParameter(
              'orderDetailsShipToDifferentAddressLabel'
            ),
            viewDetailsLabel: Utils.getConfigurationParameter('orderDetailsViewDetailsLabel')
          }
        };
      },
      getProcessedOrderDetails: function getProcessedOrderDetails() {
        var self = this;
        var orderDetails = this.model.get('details');
        var orderStatuses = orderDetails.status.split('/');
        _.each(orderStatuses, function highlightByStatus(status) {
          _.each(_.keys(self.ORDER_STATUSES_TO_HIGHLIGHT), function forEachKey(key) {
            if (_.indexOf(self.ORDER_STATUSES_TO_HIGHLIGHT[key], status) !== -1) {
              orderDetails.highlightColor = key;
            }
          });
        });
        orderDetails.statusRequiresHighlight = !!orderDetails.highlightColor;
        orderDetails.itemDetails = this.processItemData(orderDetails);
        orderDetails.status = this.processOrderStatus(orderDetails.status);
        return orderDetails;
      },
      processItemData: function processItemData(orderData) {
        var order = orderData;
        var itemDetails = orderData.itemDetails;
        var self = this;
        _.each(itemDetails, function processItems(item, index) {
          itemDetails[index].totalFormated = Utils.formatCurrency(
            item.total,
            order.currency.displaysymbol
          );
          itemDetails[index].itemLine = index;
          itemDetails[index].isForShipping = item.fulfillmentChoice
            === self.ITEM_FULFILLMENT_CHOICE_MAPPING.ship;
          itemDetails[index].isForPickUpInStore = item.fulfillmentChoice
            === self.ITEM_FULFILLMENT_CHOICE_MAPPING.pickupInStore;
          itemDetails[index].showDetailsButton = !!(
            (item.location && item.isForPickUpInStore)
            || (item.shippingAddress && item.isForShipping));
          itemDetails[index].showDifferentAddressLabel = !!(
            item.shippingAddress && item.shippingAddress
            !== order.shippingAddress);
          itemDetails[index].status = self.ITEMS_STATUS_MAPPING[item.status]
            ? self.ITEMS_STATUS_MAPPING[item.status] : '';
        });
        return itemDetails;
      },
      processOrderStatus: function processOrderStatus(status) {
        var orderStatus = status.split('/');
        var self = this;
        _.each(orderStatus, function replaceStatus(statusToProcess, index) {
          orderStatus[index] = self.ORDER_STATUS_MAPPING[statusToProcess] || '';
        });
        return orderStatus.join(' / ');
      },
      openItemDetails: function openItemDetails(event) {
        var selectedItemLine = event.target.getAttribute('data-row-index');
        var items = this.model.get('details').itemDetails;
        var selectedItem = items[selectedItemLine];
        var itemDetailsView = new ItemDetailsView({ item: selectedItem });
        event.preventDefault();
        this.options.application.getLayout().showInModal(itemDetailsView);
      }
    });
  });
